import React from 'react';
import AuthLayout from '../authLayout';

const MainLayout: React.FC = ({ children }) => {
  return <AuthLayout>{children}</AuthLayout>;
};

export default MainLayout;
